import React, { forwardRef, useState, useEffect } from 'react';
import { Colors } from '../../../constants';
import { useTranslation } from 'react-i18next';

// function to create the regular input element for name and email
const  TextDefaultElement = forwardRef((props, ref) => {
    const [ focusBorderColor, setFocusBorderColor ] = useState(`#${Colors.primaryColor}`);
    const { t } = useTranslation();

    useEffect(() => {
        setFocusBorderColor(`#${Colors.disabledText}`);
    },
    []);

    return (
        <div className="input-section" key={props.index}>
            <div className="input-nav field-label">
                <label>
                    {props.data === 'email' ? t('Email') : t('Name')}
                    <span className="required" style={{ color: props.color }}> *</span>
                </label>
                <div className="field-input">
                    <input
                        required
                        ref={ref}
                        defaultValue={props.defaultValue}
                        type={props.data === "email" ? "email" : "text"}
                        className="input"
                        onFocus={ () => setFocusBorderColor(props.color) }
                        onBlur={ () => setFocusBorderColor(`#${Colors.disabledText}`) }
                        style={{ borderColor: focusBorderColor }} />
                </div>
            </div>
        </div>
    )
});

export default TextDefaultElement;
